import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { setActivePage, setActiveChildPage } from '../../../redux/actions/active-page'
import DashboardHelpCenterWelcomeNavigation from './dashboard-help-center-welcome-navigation'
import DashboardHelpCenterWelcomeDisplay from './dashboard-help-center-welcome-display'
import { useDispatch } from 'react-redux'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(setActivePage("helpcenter"))
	})

    return(
        <section className="dashboard-help-center-section">
            <div className="inner-dashboard-help-center-container">
                <Row>
                    <Col className="content-col">
                        <DashboardHelpCenterWelcomeDisplay/>
                    </Col>
                    <Col className="menu-col">
                        <DashboardHelpCenterWelcomeNavigation/>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Index


